import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ChangePasswordComponent } from './pages/profile/change-password/change-password.component';
import { AuthGuard } from 'src/app/_helpers/auth.guard';
import { SecurityGuard } from 'src/app/_helpers/security.guard';
import { IpWhitelistingComponent } from './pages/ip-whitelisting/ip-whitelisting.component';
import { WebhookManagementComponent } from './pages/webhook-management/webhook-management.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { IntegrationGuideComponent } from './pages/integration-guide/integration-guide.component';
import { SupportComponent } from './pages/support/support.component';
import { EncryptionSecretComponent } from './pages/encryption-secret/encryption-secret.component';
import { APIExplorerComponent } from './pages/api-explorer/api-explorer.component';
import { HomeComponent } from './pages/home/home.component';
import { ApiCredentialComponent } from './pages/api-credential/api-credential.component';


export const AppRoutes: Routes = [
  {
        path: '',
        redirectTo: 'auth/landing',
        pathMatch: 'full',
    },{
        path: '',
        component: AdminLayoutComponent,
        children: [
          {
            path: 'dashboard',
            canActivate: [AuthGuard, SecurityGuard],
            component: DashboardComponent
          },
          {
            path: 'profile',
            canActivate: [AuthGuard, SecurityGuard],
            component: ProfileComponent
          },
          {
            path: 'home',
            canActivate: [AuthGuard, SecurityGuard],
            component: HomeComponent
          },
          {
            path: 'profile/change-password',
            canActivate: [AuthGuard, SecurityGuard],
            component: ChangePasswordComponent
          },
          {
            path: 'ip-whitelisting',
            canActivate: [AuthGuard, SecurityGuard],
            component: IpWhitelistingComponent
          },
          {
            path: 'support',
            canActivate: [AuthGuard, SecurityGuard],
            component: SupportComponent
          },
          {
            path: 'webhook-management',
            canActivate: [AuthGuard, SecurityGuard],
            component: WebhookManagementComponent
          },
          {
            path: 'user-management',
            canActivate: [AuthGuard, SecurityGuard],
            component: UserManagementComponent
          },
          {
            path: 'integration-guide',
            canActivate: [AuthGuard, SecurityGuard],
            component: IntegrationGuideComponent
          },
          {
            path: 'api-credential',
            canActivate: [AuthGuard, SecurityGuard],
            component: ApiCredentialComponent
          },
          {
            path: 'api-explorer',
            canActivate: [AuthGuard, SecurityGuard],
            component: APIExplorerComponent
          },
          {
            path: 'encryption-secret',
            canActivate: [AuthGuard, SecurityGuard],
            component: EncryptionSecretComponent
          }
        ]
        },{
            path: '',
            component: AuthLayoutComponent,
            children: [{
                path: 'auth',
                loadChildren: () => import('./pages/pages.module').then(x=>x.PagesModule)
            }]
        }
];
